import { useFetchFlowDeletionImpact } from 'api/flows';
import { useMemo } from 'react';


export const useFlowDeletionMessage = (flowDescription) => {
  const flowName = useMemo(() => (
    flowDescription?.name
      ? `${flowDescription.name} (${flowDescription.displayID})`
      : flowDescription?.displayID) ?? '',
  [flowDescription]);

  const {
    data: deletionImpact,
    isLoading: isLoadingImpact,
    isError: isImpactError,
  } = useFetchFlowDeletionImpact(flowDescription?.ID, {
    enabled: !!flowDescription?.ID,
  });

  const confirmationMessage = useMemo(() => {
    if (isLoadingImpact) {
      return 'Loading deletion impact...';
    }

    if (isImpactError || !deletionImpact) {
      return `⚠️ Are you sure you want to delete "${flowName}"?

This action will:
• Delete the base flow and all its versions
• Remove all provisioned instances from Clean Rooms
• Delete all associated flow runs and their results

This action cannot be undone.`;
    }

    const { cleanRoomCount = 0, totalFlowRuns = 0 } = deletionImpact;

    return `⚠️ Are you sure you want to delete: ${flowName}?

This will permanently:
• Remove from ${cleanRoomCount} clean room${cleanRoomCount === 1 ? '' : 's'}
• Delete ${totalFlowRuns} flow run${totalFlowRuns === 1 ? '' : 's'}
• Cancel any active runs
• Remove all scheduled runs

This cannot be undone.`;
  }, [flowName, deletionImpact, isLoadingImpact, isImpactError]);

  return {
    confirmationMessage,
    isLoadingImpact,
  };
};
